import React from "react";
import GenericOrdersListing from "@Pages/OrderListing/GenericOrdersListing.js";
import ContentPasteOffRoundedIcon from '@mui/icons-material/ContentPasteOffRounded';
import ChatPopup from "@Pages/GenericOrderChat/ChatPopup.jsx";
function CanceledOrdersListing() {
    return (
        <GenericOrdersListing
            title="Canceled Orders"
            isReleased={false}
            isCanceled={true}
            readOnly={true}
            icon={ContentPasteOffRoundedIcon}
            ChatPopup={ChatPopup}
        />
    );
}

export default CanceledOrdersListing;